import classNames from 'classnames'

import { HeadlineTwo } from 'content-components/_Primatives/Headlines'
import CommentToggleButton from 'ui-component-library/components/CommentToggleButton'
import { useMediaQuery } from 'ui-component-library/components/MediaQuery'

import style from './style.scss'

type Props = {
  className?: string
  commentLabelText: string
  commentsCount?: number
  commentsUrl?: string
  headlineText?: string
}

function FeaturedContentHeader({
  className,
  commentsCount,
  commentsUrl,
  commentLabelText,
  headlineText,
}: Props) {
  const { belowTablet } = useMediaQuery({
    tablet: true,
  })

  if (!headlineText && !commentsUrl) {
    return null
  }

  return (
    <header className={classNames(style.wrapper, className)}>
      {headlineText && (
        <HeadlineTwo className={style.headline}>{headlineText}</HeadlineTwo>
      )}
      {commentsUrl && !belowTablet && (
        <CommentToggleButton
          className={style.commentButton}
          labelText={commentLabelText}
          count={commentsCount}
          url={commentsUrl}
          topicText={headlineText}
        />
      )}
    </header>
  )
}
export default FeaturedContentHeader
